import React from 'react';
import FormComponent from '../Components/SubmitForm/SubmitForm';
import { HiOutlineMail, HiOutlineLocationMarker } from 'react-icons/hi';
import { IoLogoLinkedin } from 'react-icons/io';
import './Contact.css';

export const Contact = () => {
  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="contact-hero">
        <div className="container">
          <span className="badge">Get in Touch</span>
          <h1>You Aspire, We Transpire</h1>
          <p>
            Ready to start your digital transformation journey? Let's talk about
            how we can help your business grow.
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Let's Connect</h2>
              <p>
                Fill out the form to schedule an appointment or receive more information.
                We look forward to speaking with you.
              </p>
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="contact-method-icon">
                    <HiOutlineMail />
                  </div>
                  <div>
                    <h4>Email</h4>
                    <a href="mailto:support@1waydoor.com">support@1waydoor.com</a>
                  </div>
                </div>
                <div className="contact-method">
                  <div className="contact-method-icon">
                    <IoLogoLinkedin />
                  </div>
                  <div>
                    <h4>LinkedIn</h4>
                    <a href="https://www.linkedin.com/company/1waydoor" target="_blank" rel="noreferrer">
                      /company/1waydoor
                    </a>
                  </div>
                </div>
                <div className="contact-method">
                  <div className="contact-method-icon">
                    <HiOutlineLocationMarker />
                  </div>
                  <div>
                    <h4>Location</h4>
                    <p>United States</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-form-wrapper">
              <FormComponent />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
